/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-16 10:48:46
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-06 12:18:44
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ConfigProvider/index.tsx
 */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { linkList } from 'src/request/link';
import { iosList } from 'src/request/currency';
import {
  onInitState,
  onInitCurrencies,
  onBasicSettingChange,
  onAreaCodeChange,
  onSalesChannelsChange,
} from './slice';
import { withDragDropContext } from 'src/components/ReactDNDBackend';
import { getBasicSetting, getAreaCodeAll } from 'src/request/common';

import { getSalesChannels } from 'src/request/salesChannel/salesChannel';
import {
  UPDATE_GLOBAL_CONFIG_SCS,
  UPDATE_STORE_SETTING,
} from 'src/tools/constant';
import emit from 'src/tools/event';

function ConfigProvider({ children }) {
  const dispatch = useDispatch();
  const handleOnUpdateSalesChannels = () => {
    getSalesChannels().then((res) => {
      dispatch(onSalesChannelsChange(res));
    });
  };
  const handleOnUpdateStoreSetting = () => {
    getBasicSetting().then((res) => {
      dispatch(onBasicSettingChange(res || {}));
    });
  };
  useEffect(() => {
    linkList().then((res) => {
      dispatch(onInitState(res || []));
    });
    iosList().then((res) => {
      dispatch(onInitCurrencies(res || []));
    });
    getAreaCodeAll().then((res) => {
      res.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      dispatch(onAreaCodeChange(res));
    });
    //console.log('res', res);
    handleOnUpdateSalesChannels();
    handleOnUpdateStoreSetting();
    emit.on(UPDATE_GLOBAL_CONFIG_SCS, handleOnUpdateSalesChannels);
    emit.on(UPDATE_STORE_SETTING, handleOnUpdateStoreSetting);
    return () => {
      emit.removeListener(
        UPDATE_GLOBAL_CONFIG_SCS,
        handleOnUpdateSalesChannels,
      );
      emit.removeListener(UPDATE_STORE_SETTING, handleOnUpdateStoreSetting);
    };
  }, []);
  return <>{children}</>;
}

export default withDragDropContext(ConfigProvider);
